<div class="migrate-halo-section">
    <app-current-package [name]="data().name" [price]="data().price"/>
    <app-recomendation-package [data]="data().recommended"/>
    <app-packages-option [msisdn]="msisdn()"/>
</div>